import {
	DELETE_PERMISSION,
	SET_PERMISSION,
	RESET_PERMISSION
} from "./contants";
export default {
	[DELETE_PERMISSION]: (state, payload) => {
		state.permissionsChecked = state.permissionsChecked.filter((permission)=>permission !== payload);
	},
	[RESET_PERMISSION]: (state, payload) =>{
		state.permissionsChecked = []
		state.permissionsChecked = payload || []
	},
	[SET_PERMISSION]: (state, payload) => {
		if (!state.permissionsChecked.find((permission)=>permission === payload)){
			state.permissionsChecked.push(payload)
		}
	}
};
